import { parse, stringify } from 'hub-http/helpers/params';
export const getQueryString = queryParams => {
  if (!queryParams) {
    return window.location.search.slice(1);
  }
  return stringify(queryParams);
};
export const getQueryParams = () => parse(getQueryString());
export const getQueryParam = key => parse(getQueryString())[key];